/**
 * LongFormModal — wrapper around the shared <Modal/> with typography body
 * defaults for long-form content (lead paragraph + uppercase sections +
 * bulleted lists). Use the helpers from ./parts to build the body.
 *
 * Visual language is fixed; behaviour delegates to <Modal/>.
 */

import type { ReactNode } from 'react';
import { Modal } from '../Modal/Modal';
import type { ModalSize } from '../Modal/Modal';
import styles from './LongFormModal.module.css';

export interface LongFormModalProps {
  title: string;
  onClose: () => void;
  /** Width preset. Default: 'xl' (820px) — long-form needs more horizontal
   *  room than the standard dialog so the body doesn't turn into a vertical
   *  ribbon on desktop. Caller can override (e.g. 'lg' in dense layouts). */
  size?: ModalSize;
  /** Body content — compose with <Lead/>, <Section/>, <Para/>, <List/>. */
  children: ReactNode;
  /** Optional footer content. */
  footer?: ReactNode;
}

export const LongFormModal = ({
  title,
  onClose,
  size = 'xl',
  children,
  footer,
}: LongFormModalProps) => (
  <Modal
    title={title}
    onClose={onClose}
    size={size}
    bodyClassName={styles.body}
    footer={footer}
  >
    {children}
  </Modal>
);

export default LongFormModal;
